import { HTMLAttributes } from 'react'
import { cva, VariantProps } from 'class-variance-authority'

import Section from '@/components/base/section'

import { cn } from '@/lib/utils'

const spacerVariants = cva(['border-0 bg-transparent'], {
  variants: {
    variant: {
      xxs: 'pt-0',
      xs: 'pt-[3rem] md:pt-[1rem]',
      sm: 'pt-[3.2rem] md:pt-[5.6rem]',
      md: 'pt-[6.4rem] md:pt-[17.2rem]',
      lg: 'pt-[11.2rem] md:pt-[17.2rem]',
      xl: 'pt-[11.2rem] md:pt-[22rem]',
      '2xl': 'pt-[17.2rem] md:pt-[22rem]'
    }
  },
  defaultVariants: {
    variant: 'md'
  }
})

export type SpacerProps = HTMLAttributes<HTMLHRElement> & VariantProps<typeof spacerVariants>

const Spacer = ({ className, variant, ...props }: SpacerProps) => {
  return (
    <Section asChild className={cn(spacerVariants({ variant, className }))} {...props}>
      <hr />
    </Section>
  )
}

export default Spacer
